import { AppRoutes } from "../enums/appRoutes";
import {
  DealPhaseLabel,
  DealPhaseValue,
  LegalLinkLabel,
  PrimaryNavLabel,
  SidebarNavLabel,
} from "../enums/labels";
import { PLANNING_VIEW_ALLOWED_ROLES, RAID_VIEW_ALLOWED_ROLES } from "../enums/roleKeys";
import type { SidebarIconKey } from "../layout/sidebarIcons";

export interface SidebarNavItem {
  to: string;
  label: string;
  iconKey: SidebarIconKey;
  requiredRoles?: readonly string[];
}

/** Primary navbar links (route + label) */
export const primaryNavItems = [
  { to: AppRoutes.planning, label: PrimaryNavLabel.Planning },
  { to: AppRoutes.value, label: PrimaryNavLabel.Value },
  { to: AppRoutes.imoSummary, label: PrimaryNavLabel.ImoSummary },
  { to: AppRoutes.steerCo, label: PrimaryNavLabel.SteerCo },
] as const;

/** Deal phase select options (value + label) */
export const dealPhaseOptions = [
  { value: DealPhaseValue.All, label: DealPhaseLabel.All },
  { value: DealPhaseValue.PreSign, label: DealPhaseLabel.PreSign },
  { value: DealPhaseValue.SigningToClose, label: DealPhaseLabel.SigningToClose },
  { value: DealPhaseValue.Day1, label: DealPhaseLabel.Day1 },
  { value: DealPhaseValue.First100Days, label: DealPhaseLabel.First100Days },
] as const;

/** Sidebar nav items: route, label, iconKey (maps to Figma SVG icons) */
export const sidebarNavItems = [
  {
    to: AppRoutes.integrationPlanning,
    label: SidebarNavLabel.IntegrationPlanning,
    iconKey: "integrationPlanning" as SidebarIconKey,
    requiredRoles: PLANNING_VIEW_ALLOWED_ROLES,
  },
  {
    to: AppRoutes.raid,
    label: SidebarNavLabel.Raid,
    iconKey: "raid" as SidebarIconKey,
    requiredRoles: RAID_VIEW_ALLOWED_ROLES,
  },
  {
    to: AppRoutes.decisionsLog,
    label: SidebarNavLabel.DecisionsLog,
    iconKey: "decisionsLog" as SidebarIconKey,
    requiredRoles: RAID_VIEW_ALLOWED_ROLES,
  },
  {
    to: AppRoutes.checklist,
    label: SidebarNavLabel.Checklist,
    iconKey: "checklist" as SidebarIconKey,
    requiredRoles: PLANNING_VIEW_ALLOWED_ROLES,
  },
] as const satisfies readonly SidebarNavItem[];

/** Footer legal links (to + label). Replace "#" with real paths when available. */
export const legalLinkItems = [
  { to: "#", label: LegalLinkLabel.LegalNotices },
  { to: "#", label: LegalLinkLabel.Privacy },
  { to: "#", label: LegalLinkLabel.CookiePolicy },
  { to: "#", label: LegalLinkLabel.LegalDisclaimer },
  { to: "#", label: LegalLinkLabel.TermsAndConditions },
] as const;
